import React, { useState } from "react";
import { Modal, Form, Row, Col } from "antd";
import {  eContentFields } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { RenderHelper } from "../../utils/render-helper";

export const CreateModal = ({ dataSource, setDataSource }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();

    setDataSource([...dataSource, values]);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <StyledButton bgColor="yellow" onClick={showModal} className="mb-3">
        <div className="pb-1">Thêm mới</div>
      </StyledButton>

      <Modal
        title={<StyledTitle level={4}>NHÂN SỰ ĐĂNG KÝ KHÓA HỌC</StyledTitle>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <RenderHelper  fields={eContentFields}/>
            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
